import React, { useEffect, useState } from 'react'
import { Link as RouterLink, useLocation } from 'react-router-dom'
import PropTypes from 'prop-types'
import firebase from 'firebase/app'
import {
    Avatar,
    Box,
    Divider,
    Drawer,
    Hidden,
    List,
    Typography,
    makeStyles
} from '@material-ui/core'
import {
    BarChart as DashBoardIcon,
    Clipboard as ReportsIcon,
    Calendar as EventsIcon,
    Users as UsersIcon,
    Send as PublishIcon,
    Flag as PagesIcon,
    Layout as PostsIcon,
    Settings as SettingsIcon
} from 'react-feather'
import NavItem from './NavItem'

// const user = {
//   avatar: '/static/images/avatars/avatar_6.png',
//   jobTitle: 'Senior Developer',
//   name: 'Katarina Smith'
// };

const items = [
    {
        href: '/app/dashboard',
        icon: DashBoardIcon,
        title: 'Dashboard'
    },
    {
        href: '/app/publisher',
        icon: PublishIcon,
        title: 'Publisher'
    },
    {
        href: '/app/pages',
        icon: PagesIcon,
        title: 'Pages'
    },
    {
        href: '/app/users',
        icon: UsersIcon,
        title: 'Users'
    },
    {
        href: '/app/posts',
        icon: PostsIcon,
        title: 'Posts'
    },
    {
        href: '/app/events',
        icon: EventsIcon,
        title: 'Events'
    },
    {
        href: '/app/reports',
        icon: ReportsIcon,
        title: 'Reports'
    },
    {
        href: '/app/settings',
        icon: SettingsIcon,
        title: 'Settings'
    }
]

const useStyles = makeStyles(() => ({
    mobileDrawer: {
        width: 256
    },
    desktopDrawer: {
        width: 256,
        top: 64,
        height: 'calc(100% - 64px)'
    },
    avatar: {
        cursor: 'pointer',
        width: 64,
        height: 64
    }
}))

const NavBar = ({ onMobileClose, openMobile }) => {
    const classes = useStyles()
    const location = useLocation()
    const [userData, setUserData] = useState()
    const user = firebase.auth().currentUser
    const userRef = firebase.firestore().doc(`admins/${user?.email}`)

    useEffect(() => {
        if (user) {
            userRef
                .get()
                .then((doc) => {
                    if (doc.exists) {
                        const data = doc.data()
                        setUserData({ ...data, uid: doc.id })
                        if (data.status !== 'active') {
                            userRef
                                .update({ status: 'active' })
                                .then(() =>
                                    console.log(
                                        'admin updated as active account'
                                    )
                                )
                                .catch((e) =>
                                    console.log('Cant update admin active', e)
                                )
                        }
                    } else {
                        const data = {
                            uid: user.uid,
                            email: user.email,
                            role: 'admin',
                            createDate: firebase.firestore.FieldValue.serverTimestamp(),
                            status: 'active'
                        }

                        userRef
                            .set(data)
                            .then(() => {
                                console.log('admin is created first time')
                                setUserData({ ...data, uid: user.uid })
                            })
                            .catch((e) => console.log('TRY TO CREATE', e))
                    }
                })
                .catch((e) => console.log('FIRST TIME ERROR', e))
        }
    }, [user, userRef])

    useEffect(() => {
        if (openMobile && onMobileClose) {
            onMobileClose()
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location.pathname])

    const content = (
        <Box height="100%" display="flex" flexDirection="column">
            {userData ? (
                <Box
                    alignItems="center"
                    display="flex"
                    flexDirection="column"
                    p={2}
                >
                    <Avatar
                        className={classes.avatar}
                        component={RouterLink}
                        src={userData.photoURL}
                        to="/app/account"
                    />
                    <Typography
                        className={classes.name}
                        color="textPrimary"
                        variant="h5"
                    >
                        {userData.email}
                    </Typography>
                    <Typography color="textSecondary" variant="body2">
                        Admin
                    </Typography>
                </Box>
            ) : null}
            <Divider />
            <Box p={2}>
                <List>
                    {items.map((item) => (
                        <NavItem
                            href={item.href}
                            key={item.title}
                            title={item.title}
                            icon={item.icon}
                        />
                    ))}
                </List>
            </Box>
            {/* <Box flexGrow={1} /> */}
            {/* <Box p={2} m={2} bgcolor="background.dark">
        <Typography align="center" gutterBottom variant="h4">
          Need more?
        </Typography>
        <Typography align="center" variant="body2">
          Upgrade to PRO version and access 20 more screens
        </Typography>
        <Box display="flex" justifyContent="center" mt={2}>
          <Button
            color="primary"
            component="a"
            href="https://react-material-kit.devias.io"
            variant="contained"
          >
            See PRO version
          </Button>
        </Box>
      </Box> */}
        </Box>
    )

    return (
        <>
            <Hidden lgUp>
                <Drawer
                    anchor="left"
                    classes={{ paper: classes.mobileDrawer }}
                    onClose={onMobileClose}
                    open={openMobile}
                    variant="temporary"
                >
                    {content}
                </Drawer>
            </Hidden>
            <Hidden mdDown>
                <Drawer
                    anchor="left"
                    classes={{ paper: classes.desktopDrawer }}
                    open
                    variant="persistent"
                >
                    {content}
                </Drawer>
            </Hidden>
        </>
    )
}

NavBar.propTypes = {
    onMobileClose: PropTypes.func,
    openMobile: PropTypes.bool
}

NavBar.defaultProps = {
    onMobileClose: () => {},
    openMobile: false
}

export default NavBar
